import React from 'react';
import Layout from '../../components/Layout';
import Policies from './Policies';
import messages from '../../locale/jsonMessages';

export default async function action({ params, intl }) {

  const title = intl?.formatMessage(messages.cancellationPolicies);

  // From URL
  const result = decodeURIComponent(params.type).replace(/\s/g, '');
  const policyType = result;

  return {
    title,
    component: <Layout><Policies policyType={policyType} /></Layout>,
  };
};